import React from 'react'
import {Stack, Typography} from '@mui/material'
import {NEUTRAL_SCALE} from 'src/theme-new/tokens'

interface ReadOnlyFieldProps {
  label?: string
  value?: string | null
  fullWidth?: boolean
}

export default function ReadOnlyField({label, value, fullWidth}: ReadOnlyFieldProps): JSX.Element {
  return (
    <Stack spacing={0.25} sx={{width: fullWidth ? '100%' : undefined, py: '10px'}}>
      {label && (
        <Typography variant="caption" sx={{fontWeight: 600, color: NEUTRAL_SCALE[700], textTransform: 'uppercase', letterSpacing: '0.05em'}}>
          {label}
        </Typography>
      )}
      <Typography variant="body2" sx={{color: value ? NEUTRAL_SCALE[900] : NEUTRAL_SCALE[500]}}>
        {value || '—'}
      </Typography>
    </Stack>
  )
}
